import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76e0af28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "weChatSessionCard" }
const _hoisted_2 = { class: "weChatSessionCard--avatar-area" }
const _hoisted_3 = { class: "weChatSessionCard--avatar" }
const _hoisted_4 = { class: "weChatSessionCard--msg-area" }
const _hoisted_5 = { class: "weChatSessionCard--sender" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "high-light" }
const _hoisted_9 = { class: "weChatSessionCard--content" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "newline-span"
}
const _hoisted_12 = { class: "high-light" }

import { User } from '@element-plus/icons-vue';

import { useStore } from "vuex";
import { computed } from "vue";
import { WeChatMutations, WeChatGetters, WeChatActions } from "@/store/modules/weChat";



import { defineComponent } from "vue";
const __default__ = defineComponent({
    name: "WeChatSessionCard",
})

interface highlight {
    normal: string,
    light: string,
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    msgSender: {
        type: String,
        required: true,
    },
    msgContent: {
        type: String,
        required: true,
    },
    target: {
        type: String,
        required: true,
    }
},
  setup(__props) {

const props = __props;


const store = useStore();

const searchType = computed(() => {
    return store.getters[`weChat/${WeChatGetters.getSearchType}`];
});

const highLight = (data: string): highlight[] => {
    const res = []
    if (typeof data === "string") {
        const target: string = props.target
        const matchedArr = RegExp(target, 'i').exec(data);
        if (!matchedArr || matchedArr.length === 0) {
            res.push({ normal: data, light: '' })
            return res
        }
        const firstMatchedStr = matchedArr[0];
        const temp = data.split(firstMatchedStr)
        const len = temp.length
        for (let i = 0; i < len - 1; i++) {
            res.push({ normal: temp[i], light: firstMatchedStr })
        }
        res.push({ normal: temp[len - 1], light: '' })
        return res
    } else {
        res.push({ normal: data, light: '' })
        return res
    }
}


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_unref(User))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (props.target === '' || props.target !== '' && _unref(searchType) === '用户')
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(props.msgSender), 1))
          : (props.target !== '' && _unref(searchType) !== '用户')
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(highLight(props.msgSender), (i, index) => {
                  return (_openBlock(), _createElementBlock("span", { key: index }, [
                    _createTextVNode(_toDisplayString(i.normal), 1),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(i.light), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        (props.target === '')
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(props.msgContent), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(highLight(props.msgContent), (i, index) => {
                return (_openBlock(), _createElementBlock("span", { key: index }, [
                  _createTextVNode(_toDisplayString(i.normal), 1),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(i.light), 1)
                ]))
              }), 128))
            ]))
      ])
    ])
  ]))
}
}

})